// extracted by mini-css-extract-plugin
export default {"quillToolbar":"toolbar_quillToolbar__KiXsC","lexicalToolbarAnchor":"toolbar_lexicalToolbarAnchor__8nUcL"};